import './SocketDisconnected.css';

import { Button } from 'components/Button/Button';
import { Particles } from 'components/Particles/Particles';
import { useLocale } from 'containers/App/LocaleContext';
import { type FC, memo } from 'react';

const BareSocketDisconnected: FC = () => {
  const msg = useLocale();

  const handleButtonClick = () => {
    window.location.reload();
  };

  return (
    <Particles
      button={
        <Button variant='secondary' type='button' onClick={handleButtonClick}>
          {msg.socketDisconnected.btnLabel}
        </Button>
      }
      className='socket-disconnected'
      description={msg.socketDisconnected.description}
      // We intentionally did not use moving particles here like for maintenance page.
      // Reasons:
      // - This can be running for long when you disconnect your computer from network, leaving
      //   IP Fabric open somewhere in background, wasting performance/battery for nothing.
      // - This means nothing is happening / connection to server is dead. It feels weird
      //   to indicate such thing with a fancy animation.
      particlesImage={
        <div className='socket-disconnected-particles-background' />
      }
      title={msg.socketDisconnected.title}
    />
  );
};

export const SocketDisconnected = memo(BareSocketDisconnected);
